module.exports = __webpack_public_path__ + "img/craneo.6be79e66.png";